module.exports = __webpack_public_path__ + "static/media/festival_03.75597514.jpg";